<template>
  <div class="map">
    <div
      id="myMap"
      class="mapWrap"
      v-loading="fullLoading"
      element-loading-text="正在加载..."
    ></div>
    <div class="formWrap" v-if="!assetNumber">
      <CommonForm ref="commomform" slot="header" @search="formSearch" :form-json="formjson">
      </CommonForm>
    </div>
  </div>
</template>

<script>
import formjson from './Model/Formjson.Map'
import { format } from '@manage/utils/utils'
import address_blue from '@manage/assets/freezer_online.png'
import address_gray from '@manage/assets/freezer_offline.png'
import address_red from '@manage/assets/freezer_select.png'

export default {
  name: 'Map',
  data() {
    return {
      formjson,
      assetNumber: '',
      map: null,
      markers: [],
      cluster: null,
      infoWindow: null,
      queryApi: this.$api.freezer.map_list,
      detailApi: this.$api.freezer.device_detail
    }
  },
  computed: {
    fullLoading() {
      return this.$store.state.fullLoading
    }
  },
  mounted() {
    // SN
    this.assetNumber = this.$route.query.assetNumber
    if (this.assetNumber) {
      this.formSearch({})
    }
    // 加载地图
    this.map = new AMap.Map('myMap', {
      zoom: 5, //级别
      center: [116.397428, 39.90923] //中心点坐标
    })
  },
  methods: {
    formSearch(data) {
      let params = { ...data }
      if (params.typeNumber) {
        if (params.typeNumber.length === 1) {
          params.modelName = params.typeNumber[0]
        }
        if (params.typeNumber.length === 2) {
          params.modelName = params.typeNumber[0]
          params.assetId = params.typeNumber[1]
        }
        delete params.typeNumber
      }
      params.devType = '01'
      if (this.assetNumber) {
        params.assetNumber = this.assetNumber
      }

      this.$store.commit('SET_FULL_LOADING', true)
      const _this = this
      this.$ajax.get(this.queryApi, params).then((res) => {
        this.$nextTick(() => {
          this.$store.commit('SET_FULL_LOADING', false)
        })
        this.map.setZoom(5)
        if (this.cluster) {
          this.cluster.setMap(null)
        }
        this.markers = []
        if (this.infoWindow) {
          this.infoWindow.close()
        }
        // 聚合数据封装
        for (let i = 0; i < res.data.length; i++) {
          let iconImg =
            res.data[i][3] === 'online'
              ? res.data[i][4] === 'normal'
                ? address_blue
                : address_red
              : address_gray
          let marker = new AMap.Marker({
            position: new AMap.LngLat(Number(res.data[i][1]), Number(res.data[i][2])),
            extData: res.data[i][0],
            icon: iconImg
          })
          AMap.event.addListener(marker, 'click', (e) => {
            let id = e.target.getExtData()
            let params = {
              id: id
            }

            _this.$ajax.get(_this.detailApi, params).then((res) => {
              let temp1Str =
                '<div style="margin: 16px auto; width: 400px; font-family: Number-Bold; font-size: 36px; font-weight: bold; color: #333333; text-align: center;">' +
                format(res.data.refTemp) +
                '℃</div>'
              let temp2Str =
                '<div style="margin: 16px auto; width: 400px; font-size: 36px; color: #333333; text-align: center;">' +
                '<div style="display: inline-block; width: 50%; border-right: 1px solid #F2F3F4;"><div style="font-family: Number-Bold;">' +
                format(res.data.refTemp) +
                '℃</div><div style="font-size: 14px; color: #655D5B;">温区一</div></div>' +
                '<div style="display: inline-block; width: 50%;"><div style="font-family: Number-Bold;">' +
                format(res.data.freTemp) +
                '℃</div><div style="font-size: 14px; color: #655D5B;">温区二</div></div>' +
                '</div>'
              let tempStr = res.data.room === 1 ? temp1Str : temp2Str
              let onlineStr =
                '<span style="display: inline-block; margin-left: 8px; width: 32px; height: 20px; font-size: 12px; color: #ffffff; text-align: center; background: #539CFF; border-radius: 2px;">在线</span>'
              let offlineStr =
                '<span style="display: inline-block; margin-left: 8px; width: 32px; height: 20px; font-size: 12px; color: #ffffff; text-align: center; background: #A8ABB0; border-radius: 2px;">离线</span>'
              let stateStr = res.data.online === 'online' ? onlineStr : offlineStr
              let alarmStr =
                res.data.state === 'normal'
                  ? ''
                  : '<div style="margin-top: 16px; padding-left: 14px; height: 26px; line-height: 26px; font-size: 14px; color: #EC6161; background: rgba(236,97,97,0.1); border-radius: 4px;"><i class="el-icon-warning" style="margin-right: 8px; font-size: 16px; vertical-align: middle;"></i>设备报警</div>'
              let str =
                tempStr +
                '<div><table style=" line-height: 20px; font-size: 14px; color: #666666;">' +
                '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">设备SN码：</td><td>' +
                format(res.data.assetNumber) +
                stateStr +
                '</td></tr>' +
                '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">设备型号：</td><td>' +
                format(res.data.productModel) +
                '</td></tr>' +
                '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">负责部门：</td><td>' +
                format(res.data.departmentName) +
                '</td></tr>' +
                '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">门店名称：</td><td>' +
                format(res.data.shopName) +
                '</td></tr>' +
                '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">详细地址：</td><td>' +
                format(res.data.locationAddress) +
                '</td></tr>' +
                '</table></div>' +
                alarmStr
              _this.infoWindow = new AMap.InfoWindow({
                content: str,
                offset: new AMap.Pixel(0, -30)
              })
              _this.infoWindow.open(_this.map, marker.getPosition())
            })
          })
          // this.map.add(marker)
          this.markers.push(marker)
        }
        //添加聚合组件
        this.cluster = new AMap.MarkerClusterer(
          this.map, // 地图实例
          this.markers // 海量点组成的数组
        )
        this.cluster.on('click', (e) => {
          if (this.map.getZoom() === e.target.getMaxZoom()) {
            let position = [e.lnglat.lng, e.lnglat.lat]
            let ids = []
            console.log(e.markers)

            for (let i = 0; i < e.markers.length; i++) {
              ids.push(e.markers[i].De.extData)
            }
            let params = {
              ids: ids.join()
            }
            _this.$ajax.get(_this.$api.freezer.cluster_list, params).then((res) => {
              let str = '<div style="height: 560px;">'
              for (let i = 0; i < res.data.length; i++) {
                let temp1Str =
                  '<div style="margin: 0 auto 16px; padding-top: 16px; width: 400px; font-family: Number-Bold; font-size: 36px; font-weight: bold; color: #333333; text-align: center;' +
                  (i > 0 ? ' border-top: 1px solid #E9EBED;' : '') +
                  '">' +
                  format(res.data[i].refTemp) +
                  '℃</div>'
                let temp2Str =
                  '<div style="margin: 0 auto 16px; padding-top: 16px; width: 400px; font-size: 36px; color: #333333; text-align: center;">' +
                  '<div style="display: inline-block; width: 50%; border-right: 1px solid #F2F3F4;"><div style="font-family: Number-Bold;">' +
                  format(res.data[i].refTemp) +
                  '℃</div><div style="font-size: 14px; color: #655D5B;">温区一</div></div>' +
                  '<div style="display: inline-block; width: 50%;"><div style="font-family: Number-Bold;">' +
                  format(res.data[i].freTemp) +
                  '℃</div><div style="font-size: 14px; color: #655D5B;">温区二</div></div>' +
                  '</div>'
                let tempStr = res.data[i].room === 1 ? temp1Str : temp2Str
                let onlineStr =
                  '<span style="display: inline-block; margin-left: 8px; width: 32px; height: 20px; font-size: 12px; color: #ffffff; text-align: center; background: #539CFF; border-radius: 2px;">在线</span>'
                let offlineStr =
                  '<span style="display: inline-block; margin-left: 8px; width: 32px; height: 20px; font-size: 12px; color: #ffffff; text-align: center; background: #A8ABB0; border-radius: 2px;">离线</span>'
                let stateStr = res.data[i].online === 'online' ? onlineStr : offlineStr
                let alarmStr =
                  res.data[i].state === 'normal'
                    ? ''
                    : '<div style="margin-top: 16px; padding-left: 14px; height: 26px; line-height: 26px; font-size: 14px; color: #EC6161; background: rgba(236,97,97,0.1); border-radius: 4px;"><i class="el-icon-warning" style="margin-right: 8px; font-size: 16px; vertical-align: middle;"></i>设备报警</div>'
                str +=
                  '<div style="padding-bottom: 24px;">' +
                  tempStr +
                  '<div><table style=" line-height: 20px; font-size: 14px; color: #666666;">' +
                  '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">设备SN码：</td><td>' +
                  format(res.data[i].assetNumber) +
                  stateStr +
                  '</td></tr>' +
                  '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">设备型号：</td><td>' +
                  format(res.data[i].productModel) +
                  '</td></tr>' +
                  '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">负责部门：</td><td>' +
                  format(res.data[i].departmentName) +
                  '</td></tr>' +
                  '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">门店名称：</td><td>' +
                  format(res.data[i].shopName) +
                  '</td></tr>' +
                  '<tr><td style="display: inline-block; width: 100px; color: #999999; text-align: right;">详细地址：</td><td>' +
                  format(res.data[i].locationAddress) +
                  '</td></tr>' +
                  '</table></div>' +
                  alarmStr +
                  '</div>'
              }
              str += '</div>'
              _this.infoWindow = new AMap.InfoWindow({
                content: str,
                offset: new AMap.Pixel(0, -30)
              })
              _this.infoWindow.open(_this.map, position)
            })
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.map {
  position: relative;
  width: 100%;
  height: 100%;
  .mapWrap {
    width: 100%;
    height: 100%;
  }
  .formWrap {
    position: absolute;
    top: 24px;
    left: 24px;
    right: 24px;
    padding: 16px 16px 8px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.05);
    border-radius: 4px;
  }
  /deep/ .amap-info-close {
    top: 20px;
    right: 20px !important;
  }
  /deep/ .amap-info-content {
    padding: 24px;
  }
  /deep/ .amap-logo {
    //去掉高德地图logo
    opacity: 0;
    display: none;
  }
  /deep/ .amap-copyright {
    //去掉高德的版本号
    opacity: 0;
  }
}
</style>
